import React from 'react';
import ResetButton from '../buttons/ResetButton';
import FormColors from './FormColors';
import AddColorButton from '../buttons/AddColorButton';
import RandomizeButton from '../buttons/RandomizeButton';
import DownloadSVGButton from '../buttons/DownloadSVGButton';
import DownloadPNGButton from '../buttons/DownloadPNGButton';
import FormBackgroundColor from './FormBackgroundColor';
import FormText from './FormText';
import FormIconsNumber from './FormIconsNumber';

const Form = () => {

    return (
        <div className="md:shadow-lg md:shadow-slate-200 md:rounded md:p-4 flex flex-wrap">

            <div className="grid grid-cols-2 gap-4 mb-6 mx-auto md:grid-cols-4 mt-4">
                <DownloadSVGButton />
                <DownloadPNGButton />
                <RandomizeButton />
                <ResetButton />
            </div>

            <div className="w-full flex flex-wrap mt-4 border-t border-t-gray-200 pt-10">
                <FormText />

                <FormBackgroundColor />

                <FormIconsNumber />

                <div className="form-colors-list flex flex-wrap gap-4 mb-4 mt-4 items-center xl:flex-1">
                    <FormColors />
                    <AddColorButton />
                </div>
            </div>
        </div>
    )
};

export default Form;